import type { Language } from '@wix/thunderbolt-becky-types';
import type { WTwitterLanguage } from './types';

export const getLanguage = (
  dataLang: WTwitterLanguage,
  userLang: Language,
): string => {
  return dataLang === 'userLang' ? userLang : dataLang;
};
